import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import { grey } from '@material-ui/core/colors';


import {Checkbox, Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {Container, Box, Typography} from '@material-ui/core'
import {Button, TextField} from '@material-ui/core';
import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';

import {ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getIndexByID, getObjectByID } from '../../../api/helpers';
import { CheckBox, CheckBoxTwoTone, Label } from '@material-ui/icons';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

class SelectUsersDialog_ extends React.Component{

    constructor(props){
        super(props)
        
        let panelsExpanded = {}
        let defaultNetID = this.props.networkID ? this.props.networkID : ( this.props.networks ? this.props.networks[0].ID : null)
        if(defaultNetID) panelsExpanded[defaultNetID] = true

        this.state = {
            changed: false,
            panelsExpanded: panelsExpanded,
            userFilter: '',
            errors: {
                userName: false
            },
            users: this.props.users,
            checked: false
        }

        this.handleSelect = this.handleSelect.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleFilterInput = this.handleFilterInput.bind(this)
        this.handleSelectionAllClick = this.handleSelectionAllClick.bind(this) 
    }

    handleSelect(){
        if(this.validate()){
            this.props.onAction({type: 'SELECT_USERS_DIALOG_SELECT', users: this.state.users })
        }
    }

    handleClose(){
        this.props.onAction({type: 'SELECT_USERS_DIALOG_CLOSE'})
    }

    handleFilterInput(event){
        const val =  event.target.value
        this.setState({[event.target.name]: val})
    }

    validate(){
        let error = false
        return !error;
    }


    togglePanel(event, expanded, panel){
        this.setState(state => {
            state.panelsExpanded[panel] = expanded
            return state
        })
    }

    select(netID, userID){
        let network = getObjectByID(netID, this.props.networks)
        let user = getObjectByID(userID, network.users)

        let selected = {
            networkID: netID,
            userID: user.ID,
            user: user.Name
        }

        this.setState({selected: selected})
    }

    selectClose(netID, userID){
        let network = getObjectByID(netID, this.props.networks)
        let user = getObjectByID(userID, network.users)

        let selected = {
            networkID: netID,
            userID: user.ID,
            user: user.Name
        }

        if(this.validate()){
            this.props.onAction({type: 'SELECT_USER_DIALOG_SELECT', ...selected })
        }
    }

    getUsers(users){

        users.sort((item1, item2) => (item1.Name > item2.Name))
        return users

    }

    networkSelected(net){
        let selected = false
        net.users.forEach(user => {
            selected = selected || this.userSelected(user)
        });
        //console.log("networkSelected")
        //console.log(selected)
        return selected
    }

    userSelected(user){
        let item = getObjectByID(user.GUID, this.state.users)
        let selected = item!==null

        //console.log("userSelected")
        //console.log(selected)

        return selected
    }

    selectAll(network, checked){
        let users = this.state.users

        network.users.forEach(user => {
            let index = getIndexByID(user.GUID, users)
            if(checked && index===null){
                users.push({ID: user.GUID, Name: user.Name})
            }
            if(!checked && index!==null){
                users.splice(index, 1)
            }
        })

        this.setState({users: users})
    }

    selectUser(user, checked){
        let users = this.state.users
        let index = getIndexByID(user.GUID, users)
        if(checked && index===null){
            users.push({ID: user.GUID, Name: user.Name})
        }
        if(!checked && index!==null){
            users.splice(index, 1)
        }
        this.setState({users: users})
    }


    handleSelectionAllClick(network){
        return (event)=>{
            this.selectAll(network, event.target.checked)
        }
    }

    handleSelectionItem(user){
        return (event)=>{
            this.selectUser(user, event.target.checked)
        }
    }


    getNetworks(){
        let networks = []
        if(this.props.networkID){
            networks = this.props.networks.filter(net => net.ID==this.props.networkID)
        }else{
            networks = this.props.networks
        }

        let filter = this.state.userFilter.toLowerCase()
        networks = networks.map(net => this.getNetwork(net, filter))

        return networks
    }

    getNetwork(network, filter){
        let net
        if(filter){
            net = {
                ID: network.ID, 
                Name: network.Name,
                users: network.users.filter(
                    item => item.Name.toLowerCase().indexOf(filter) >= 0 && item.Type!=10
                )
            }
        }else{
            net = {
                ID: network.ID, 
                Name: network.Name,
                users: network.users.filter(
                    item => item.Type!=10
                )
            }
        }

        return net
    }


    render(){
        const {t} = this.props

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            icon:{
                width: 30
            },
            addIcon: {
                color: 'white'
            }
        };

        const title = t('SelectItem')

        let networks = this.getNetworks() 

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:300}}>        

            <Box textAlign="center">
                <TextField
                    name="userFilter"
                    id="userFilter"
                    onChange={this.handleFilterInput}
                    label={t("Filter")}
                    value={this.state.userFilter}
                    style={{width:'100%'}}
                    error={false}
                    autoComplete="new-password"
                />
            </Box>

            {networks.map(net=>(

            <ExpansionPanel key={net.ID}
                expanded={this.state.panelsExpanded[net.ID]==undefined?false:this.state.panelsExpanded[net.ID]} 
                onChange={(event, expanded) => this.togglePanel(event, expanded, net.ID)}>
                <ExpansionPanelSummary style={{background: grey[300], marginLeft:0}} expandIcon={<ExpandMoreIcon />}>
                    <Typography>{net.Name}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{display: 'block', margin:0, padding:0}}>
                    
                    <Table size="small">

                        <TableHead>
                            <TableRow>
                                <TableCell style={styles.head}>

                                    <label>
                                    <Checkbox
                                        checked={this.networkSelected(net)}

                                        icon={<CheckBoxOutlineBlankIcon style={{color:"white"}} />}
                                        checkedIcon={<CheckBox style={{color:"white"}} />}

                                        name={'net_'+net.ID}
                                        onChange={this.handleSelectionAllClick(net)}>
                                    </Checkbox>
                                    {t('SelectAll')}
                                    </label>                                
                                    
                                </TableCell>
                            </TableRow>
                        </TableHead>
                    
                    
                        <TableBody>
                        {this.getUsers(net.users).map(user=>
                            <TableRow key={user.ID}>
                                <TableCell>
                                    <label>
                                    <Checkbox 
                                        checked={this.userSelected(user)}
                                        onChange={this.handleSelectionItem(user)}></Checkbox>
                                    {user.Name}
                                    </label>
                                </TableCell>
                            </TableRow>
                        )}
                        </TableBody>
                    </Table>

                </ExpansionPanelDetails>
            </ExpansionPanel>
            ))}

            

        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSelect} variant="contained" color="primary">
            {t('Ok')}
        </Button>
        <Button onClick={this.handleClose} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const SelectUsersDialog = withTranslation()(SelectUsersDialog_);